import * as Types from '../constants/Types';

export const dataGroupAction = (filters) => ({ type: Types.GROUP_LIST_ACTION, filters });
export const dataGroupSuccess = (groups) => ({ type: Types.GROUP_LIST_SUCCESS, groups });

export const dataAllGroupAction = (filters) => ({ type: Types.GROUP_LIST_ALL_ACTION, filters });
export const dataAllGroupSuccess = (allGroups) => ({ type: Types.GROUP_LIST_ALL_SUCCESS, allGroups });

export const createGroupAction = (params) => ({ type: Types.GROUP_CREATE_ACTION, params });
export const deleteGroupAction = (params) => ({ type: Types.GROUP_DELETE_ACTION, params });
export const cloneGroupAction = (params) => ({ type: Types.GROUP_CLONE_ACTION, params });

export const getUpdateGroupAction = (params) => ({ type: Types.GROUP_GET_UPDATE_ACTION, params });
export const getUpdateGroupSuccess = (dataUpdate) => ({ type: Types.GROUP_GET_UPDATE_SUCCESS, dataUpdate });

export const updateGroupAction = (params) => ({ type: Types.GROUP_UPDATE_ACTION, params });
export const importGroupAction = (params) => ({ type: Types.GROUP_IMPORT_ACTION, params });

export const exportGroupAction = (filters) => ({ type: Types.GROUP_EXPORT_ACTION, filters });
export const exportGroupSuccess = (exGroup) => ({ type: Types.GROUP_EXPORT_SUCCESS, exGroup });

export const exportProductFeedAction = (params) => ({ type: Types.GROUP_EXPORT_PRODUCT_FEED_ACTION, params });
export const exportProductFeedSuccess = (data) => ({ type: Types.GROUP_EXPORT_PRODUCT_FEED_SUCCESS, data });

export const reindexProductAction = (params = {}) => ({ type: Types.GROUP_REINDEX_PRODUCT_ACTION, params });
export const reindexProductSuccess = () => ({ type: Types.GROUP_REINDEX_PRODUCT_SUCCESS });

export const exportVoucherGroupAction = (params) => ({ type: Types.GROUP_EXPORT_VOUCHER_ACTION, params });
// export const exportVoucherGroupSuccess = (exGroup) => ({type: Types.GROUP_EXPORT_VOUCHER_SUCCESS, exGroup});

export const createGroupTranslate = (group) => ({ type: Types.GROUP_CREATE_TRANSLATE_ACTION, group });
export const updateGroupTranslate = (group) => ({ type: Types.GROUP_UPDATE_TRANSLATE_ACTION, group });
export const deleteGroupTranslate = (group, refreshParams) => ({ type: Types.GROUP_DELETE_TRANSLATE_ACTION, group, refreshParams });

export const resetGroup = () => ({ type: Types.GROUP_RESET });